export class Scene {
}
//# sourceMappingURL=Scene.js.map